// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f172b681","81":"bd0cdb7d","84":"ea728717","243":"214064c3","297":"3482c6a8","411":"8098dd31","449":"2ccf19c9","638":"c7f049ca","650":"af61f489","689":"dd282a42","787":"9b509a63","895":"3633a1b3"}[chunkId] + ".chunk.js";
};